/* eslint-disable i18next/no-literal-string */
const ScheduleWarning = (
    props: React.ImgHTMLAttributes<HTMLImageElement>
): React.ReactElement => {
    return (
        <img src="/schedule-warning.webp" alt="schedule-warning" {...props} />
    )
}

export default ScheduleWarning
